import {effect, Injectable, signal, WritableSignal} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable, tap} from "rxjs";
import {UserModel} from "../../models/resources/user.model";
import {LanguageService} from "../resources/language.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: WritableSignal<UserModel | null>

  constructor(private http: HttpClient,
              private languageService: LanguageService) {
    this.user = signal(JSON.parse(localStorage.getItem('user') ?? 'null'))

    effect(() => {
      if (this.user()) {
        localStorage.setItem('user', JSON.stringify(this.user()!))
        if(this.user()?.language)
          this.languageService.activeLanguage.set(this.user()!.language!)
      } else
        localStorage.removeItem('user')
    })
  }

  public login(username: string, password: string) {
    return this.http.post<{token: string}>(environment.apiUrl + '/login', {
      username,
      password
    })
      .pipe(
        tap((response: any) => {
          this.user.set(response);
        })
      );
  }

  public logout(): Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/logout', {})
      // .pipe(
      //   tap(() => {
      //     this.token.set(null)
      //   })
      // )
  }

  public updateLanguage(languageId: number) {
    return this.http.patch(environment.apiUrl + `/users/${this.user()?.id}`, {
      languageId
    })
  }
}
